import { onAuthStateChanged } from "firebase/auth";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

import { getFirebaseAuth } from "services/firebase/auth";

import {
  isSignedIn,
  isSigningIn,
  isSigningOut
} from "seneca-common/features/user/state";

import { isIE } from "features/common/utils/functions/browser";
import {
  linkToPasswordReset,
  linkToSignIn,
  linkToSignUp
} from "features/sign-up/links";
import signInWithProviderWithRedirect from "features/user/actions/auth/sso/signInWithProviderWithRedirect";

import { setForcedSignOut } from "./forcedSignOut";

export default function useRedirectOnAuthStateChanged() {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const userIdRef = useRef<string | null>(null);

  const [initialChangeDone, setInitialChangeDone] = useState<boolean>(false);
  const signingOut = useSelector(isSigningOut);
  const signingIn = useSelector(isSigningIn);
  const signedIn = useSelector(isSignedIn);

  useEffect(() => {
    const unsubscribeFirebaseEventListener = onAuthStateChanged(
      getFirebaseAuth(),
      (user: any) => {
        if (!initialChangeDone) {
          setInitialChangeDone(true);
          return;
        }
        if (
          !user &&
          !isOnAnonymousPage() &&
          !isIE() &&
          !signingIn &&
          !signingOut &&
          signedIn
        ) {
          setForcedSignOut();
          window.location = (window.location.origin + linkToSignIn()) as any;
        } else if (user && user.uid !== userIdRef.current && !signingIn) {
          window.location.reload();
        }

        userIdRef.current = user ? user.uid : null;
      }
    );

    return () => unsubscribeFirebaseEventListener();
  }, [initialChangeDone, signedIn, signingIn, signingOut]);

  useEffect(() => {
    dispatch(signInWithProviderWithRedirect(location, history));
  }, [location, history, dispatch]);
}

function isOnAnonymousPage() {
  return [linkToSignIn(), linkToSignUp(), linkToPasswordReset()].some(
    link => window.location.href === window.location.origin + link
  );
}
